import { ChangeDetectorRef, Injectable, QueryList } from '@angular/core';
import { Router } from '@angular/router';
import { ActivePanelInterface } from '@app/core/interfaces';
import { ScrollService } from '@app/core/scroll/scroll.service';
import { PanelExpandableComponent } from '@app/shared/ux/panel-expandable/panel-expandable.component';

@Injectable({
    providedIn: 'root',
})
export class PanelService {
    private panel: PanelExpandableComponent;

    constructor(private router: Router, private scrollService: ScrollService) { }

    handleQueryParams(props: ActivePanelInterface,
                      children: QueryList<PanelExpandableComponent>,
                      changeDetectorRef: ChangeDetectorRef): void {
        const { panel, scrollTo } = props;

        this.closeAllPanels(children);
        this.expandPanel(panel, true, children, changeDetectorRef);
        this.scrollTo(scrollTo, true);
    }

    private closeAllPanels(children: QueryList<PanelExpandableComponent>): void {
        children.forEach((child) => child.close());
    }

    private expandPanel(section: string,
                        expand: boolean,
                        children: QueryList<PanelExpandableComponent>,
                        changeDetectorRef: ChangeDetectorRef): void {

        this.panel = children.find((child) => {
            return child.id === section;
        });

        if (!this.panel) {
            return;
        }

        if (expand) {
            this.panel.open();
        }

        changeDetectorRef.detectChanges();
    }

    private scrollTo(section: string, scroll?: boolean): void {
        if (!scroll) {
            return;
        }

        this.scrollService.scrollElementOffset(`#${ section }`, 300);
    }
}
